export default __webpack_public_path__ + "static/media/CRAB-01.48282280.png";